import { render, staticRenderFns } from "./TakeFoodList.vue?vue&type=template&id=fa52a95c&scoped=true&"
import script from "./TakeFoodList.vue?vue&type=script&lang=js&"
export * from "./TakeFoodList.vue?vue&type=script&lang=js&"
import style0 from "./TakeFoodList.vue?vue&type=style&index=0&id=fa52a95c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa52a95c",
  null
  
)

export default component.exports